import * as storage from '../utils/storage';
import Settings from '../domain/Settings';
import {getGigyaId} from '../utils/gigya';
import {getCxenseProperties} from '../utils/cxense';
import {hasPurposesConsent, onConsent} from './privacyService';
import performance from '../utils/performance';

export type DMOISettings = {
	apiKey: string
	url?: string
}

const PROFILE_SERVICE_URL = 'https://profile-public-api.data.dpgmedia.cloud/dmoi',
	REQUIRED_CONSENTS_FOR_USE = [1, 2, 3, 4, 7, 10],
	DMOI_STORAGE_KEY = 'advert-dmoi';

let userId: string;

export async function init(): Promise<void> {
	if (!Settings.getInstance().features.dmoi) {
		userId = storage.getFromCookie('authId');

		return;
	}

	userId = _getFromStorage();

	if (!userId) {
		userId = await _fetchDMOI();

		_storeUserId();
	}
}

function _getIdentifiers() {
	return Object.fromEntries(Object.entries({
		'pw_id': storage.getFromCookie('authId'),
		'gigya_id': getGigyaId(),
		'cxense_id': getCxenseProperties()?.id
	}).filter(([, v]) => v));
}

async function _fetchDMOI(): Promise<string | null> {
	performance.mark('user - dmoi - start');

	const identifiers = _getIdentifiers();

	if (Object.keys(identifiers).length === 0) {
		return null;
	}

	const {
		apiKey,
		url = PROFILE_SERVICE_URL
	} = Settings.getInstance().dmoi;

	try {
		const response = await window.fetch(url, {
			'method': 'POST',
			'headers': {

				// @ts-ignore
				'x-api-key': apiKey
			},

			// @ts-ignore
			'body': JSON.stringify(identifiers)
		});

		return (await response.json()).dmoi;
	} catch (error) {
		console.error('[ADVERT] Could not fetch DMOI', error);

		return null;
	} finally {
		performance.mark('user - dmoi - end');
	}
}

function _storeUserId() {
	onConsent(() => {
		if (hasPurposesConsent(REQUIRED_CONSENTS_FOR_USE)) {
			storage.put(DMOI_STORAGE_KEY, JSON.stringify({
				'value': userId,
				'expiration': _getExpirationDate()
			}));
		}
	});
}

function _getExpirationDate(): string {
	const currDate = new Date();

	currDate.setDate(currDate.getDate() + 1);
	currDate.setUTCHours(1, 0, 0, 0);

	return currDate.toISOString();
}

function _getFromStorage(): string | null {
	const storageValue = storage.get(DMOI_STORAGE_KEY);

	if (!storageValue) {
		return null;
	}

	const {
		expiration,
		value
	} = JSON.parse(storageValue);

	if (new Date(expiration) < new Date()) {
		return null;
	}

	return value;
}

export function getUserId(): string {
	if (!hasPurposesConsent(REQUIRED_CONSENTS_FOR_USE)) {
		return null;
	}

	return userId;
}

